import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout, CourseHome, CourseLayout } from './components/AppLayout';
import { RequireActive, RequireAuth, RequireInstructor } from './components/guards';
import { Assessments } from './screens/Assessments';
import { CoursePlayer } from './screens/CoursePlayer';
import { Dashboard } from './screens/Dashboard';
import { InterviewPrep } from './screens/InterviewPrep';
import { Labs } from './screens/Labs';
import { LabDetail } from './screens/LabDetail';
import { MyCourses } from './screens/MyCourses';
import { MyProgram } from './screens/MyProgram';
import { QuestionPack } from './screens/QuestionPack';
import { SignIn } from './screens/SignIn';
import { Studio } from './screens/Studio';
import { StudioContent } from './screens/StudioContent';
import { StudioCourses } from './screens/StudioCourses';
import { StudioGrading } from './screens/StudioGrading';
import { StudioInterview } from './screens/StudioInterview';
import { StudioLabs } from './screens/StudioLabs';
import { StudioLearners } from './screens/StudioLearners';
import { StudioFeedback } from './screens/StudioFeedback';
import { StudioOverview } from './screens/StudioOverview';
import { StudioReports } from './screens/StudioReports';

export function App() {
  return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />

      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route element={<RequireActive />}>
            {/* '/' decides where to send you: your only/last course, or the picker. */}
            <Route index element={<CourseHome />} />
            <Route path="courses" element={<MyCourses />} />
            {/* Each course has its own URL; student content is scoped under its slug. */}
            <Route path="courses/:courseSlug" element={<CourseLayout />}>
              {/* The course opens into its curriculum (the roadmap of weeks → classes). */}
              <Route index element={<MyProgram />} />
              <Route path="progress" element={<Dashboard />} />
              {/* Back-compat for earlier URLs: /program → course home, /dashboard → /progress. */}
              <Route path="program" element={<Navigate to=".." relative="path" replace />} />
              <Route path="dashboard" element={<Navigate to="../progress" relative="path" replace />} />
              <Route path="classes/:classId" element={<CoursePlayer />} />
              {/* Back-compat for the earlier class-player URLs. */}
              <Route path="course" element={<CoursePlayer />} />
              <Route path="course/:lessonId" element={<CoursePlayer />} />
              <Route path="assessments" element={<Assessments />} />
              <Route path="assessments/:quizId" element={<Assessments />} />
              <Route path="labs" element={<Labs />} />
              <Route path="labs/:id" element={<LabDetail />} />
            </Route>
            {/* Interview prep is shared career content — deliberately not course-scoped. */}
            <Route path="interview" element={<InterviewPrep />} />
            {/* Printable pack — every question this learner may see, in one place. */}
            <Route path="questions" element={<QuestionPack />} />

            <Route element={<RequireInstructor />}>
              <Route path="studio" element={<Studio />}>
                <Route index element={<Navigate to="overview" replace />} />
                <Route path="overview" element={<StudioOverview />} />
                <Route path="reports" element={<StudioReports />} />
                <Route path="feedback" element={<StudioFeedback />} />
                <Route path="courses" element={<StudioCourses />} />
                <Route path="content" element={<StudioContent />} />
                <Route path="content/:courseSlug" element={<StudioContent />} />
                <Route path="labs" element={<StudioLabs />} />
                <Route path="interview" element={<StudioInterview />} />
                <Route path="learners" element={<StudioLearners />} />
                <Route path="grading" element={<StudioGrading />} />
              </Route>
            </Route>
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
